module.exports = __webpack_public_path__ + "media/images/products/products/prism-b360f4aa4e332269ccb8072fbdb6487c.png";